import { Component, Input, OnChanges, output } from '@angular/core';
import { DayOfWeek } from 'src/api';
import { TranslateDirective } from '@ngx-translate/core';
import { InputV2Module, ButtonV2Module } from '@schenck/rotec-components';

export interface SchedulingWeeklyModel {
  interval: number;
  daysOfWeek: DayOfWeek[];
}

@Component({
  selector: 'ma-scheduling-weekly',
  templateUrl: './scheduling-weekly.component.html',
  styleUrls: ['./scheduling-weekly.component.less', '../scheduling-interval.less'],
  imports: [TranslateDirective, InputV2Module, ButtonV2Module],
})
export class SchedulingWeeklyComponent implements OnChanges {
  @Input()
  public scheduling: SchedulingWeeklyModel;
  public readonly schedulingChange = output<SchedulingWeeklyModel>();

  public daysOfWeekOptions = [
    { value: DayOfWeek.Monday, name: DayOfWeek.Monday },
    { value: DayOfWeek.Tuesday, name: DayOfWeek.Tuesday },
    { value: DayOfWeek.Wednesday, name: DayOfWeek.Wednesday },
    { value: DayOfWeek.Thursday, name: DayOfWeek.Thursday },
    { value: DayOfWeek.Friday, name: DayOfWeek.Friday },
    { value: DayOfWeek.Saturday, name: DayOfWeek.Saturday },
    { value: DayOfWeek.Sunday, name: DayOfWeek.Sunday },
  ];

  public interval = 1;

  public intervalChange(interval: string): void {
    this.interval = Number(interval);
    this.emitSchedulingChange();
  }

  private _daysOfWeek: DayOfWeek[] = [];

  public get daysOfWeek(): DayOfWeek[] {
    return this._daysOfWeek;
  }

  public set daysOfWeek(daysOfWeek: DayOfWeek[]) {
    this._daysOfWeek = daysOfWeek;
    this.emitSchedulingChange();
  }

  private emitSchedulingChange(): void {
    this.schedulingChange.emit({ daysOfWeek: this.daysOfWeek, interval: this.interval });
  }

  public ngOnChanges(): void {
    if (!this.scheduling) {
      return;
    }

    this.interval = this.scheduling.interval;
    this._daysOfWeek = this.scheduling.daysOfWeek;
  }
}
